import React from 'react'
import Modal from '../../genericComponents/Modal'
import CircledButtonWithLabel, { LogoVariants } from '../../genericComponents/CircledButtonWithLabel'
import GeoentityPhoneModalContent from './GeoentityPhoneModalContent'
import TagActionButton from '../../genericComponents/TagActionButton'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { SPD_GEOENTITY_FANTOMAS } from '../../analytics/BiTagger'
import useCommonGeoentityClickTagProps from '../useCommonGeoentityClickTagProps'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import { useAction } from '../../utils/react-redux'
import { navigateTo } from '../../../store/history/history.actions'
import { ROUTE_MODAL } from '../../../routes'

const MODAL_ID = 'telephone'

export const GeoentityPhoneButton = () => {
  const execNavigateTo = useAction(navigateTo)

  const sendBiTagPhoneButton = useTagBiForGeoentity(SPD_GEOENTITY_FANTOMAS)
  const clickTagProps = useCommonGeoentityClickTagProps(PUB_TAG.PUB_FICHEPOI_AFFICHERNUMERO)

  return (
    <div>
      <TagActionButton
        onClick={() => {
          sendBiTagPhoneButton()
          execNavigateTo({
            route: ROUTE_MODAL,
            routeOptions: { modalId: MODAL_ID }
          })
        }}
        deferClick
        {...clickTagProps}
      >
        <CircledButtonWithLabel
          svgId="phone"
          label="geoentity.contact_info.phone"
          logoVariant={LogoVariants.sharpDarkGreyBorder}
        />
      </TagActionButton>
      <Modal
        modalId={MODAL_ID}
        style={{
          width: 219
        }}
        execNavBackOnClose={true}
      >
        <GeoentityPhoneModalContent />
      </Modal>
    </div>
  )
}

export default GeoentityPhoneButton
